// zones
export const getZonesUrl = "/api/v3/defs/region/:regionId/geoWithin";
export const createZoneUrl = "/api/v3/platform/region";
export const updateZoneUrl = "/api/v3/platform/region/:regionId";
export const deleteZoneUrl = "/api/v3/platform/region/:regionId";

// sub zones
export const getSubZonesUrl = "/api/v3/org/sub_zone/search";
export const createSubZonesUrl = "/api/v3/org/sub_zone";
export const updateSubZonesUrl = "/api/v3/org/sub_zone/:subzoneListId";
export const deleteSubZonesUrl = "/api/v3/org/sub_zone/:subzoneListId";
